/* unplugin-vue-components disabled */
// TODO: refactor to store
import {Rest} from 'utils'
import {API2_TOPICS} from 'consts/api2'
import TopicSuggestion from './topic-suggestion.vue'
const MIN_LENGTH = 2

export default {
  components: {TopicSuggestion},
  mixins: [ModelValue(Object)],
  props: {
    required: {type: Boolean, default: true},
    placeholder: {type: String, default: undefined},
    teleported: {type: Boolean, default: false},
    userId: {type: String, default: undefined},
    hideFollowed: {type: Boolean, default: false}
  },
  data() {
    return {
      el_value: undefined,
      rest: new Rest(),
      last_query: '',
      last_res: []
    }
  },
  computed: {
    empty() {
      return !Object.keys(this.value).length
    }
  },
  methods: {
    focus() {
      this.$refs.el_autocomplete.focus()
    },
    async loadAsync(query, cback) {
      if (!query || query.length < MIN_LENGTH) return cback([])
      if (this.last_query === query) {
        return cback(this.last_res)
      }

      let query_params = {query: query}
      if (this.userId) {
        query_params['user_id'] = this.userId
      }
      if (this.hideFollowed) {
        query_params['hide_followed'] = this.hideFollowed
      }
      const view_items = await this.rest.get(`${API2_TOPICS}/search`, query_params)
      if (!view_items?.length) {
        this.last_query = query
        this.last_res = []
        return cback([])
      }

      const res = []
      for (let comp of view_items) {
        res.push({
          key: comp.name,
          ...comp
        })
      }

      this.last_query = query
      this.last_res = res
      cback(res)
    },
    setValue(val) {
      this.el_value = val
      this.onInput(val)
    },
    onInput(query) {
      this.resetInput()
    },
    onSelect(item) {
      this.value = item
    },
    abortAll() {
      this.rest.abortAll()
    },
    resetInput(){
      this.abortAll()
      this.$refs.el_autocomplete.suggestions = []
      this.value = undefined
      this.last_res = []
      this.last_query = ''
    },
    clear(){
      this.resetInput()
      this.$refs.el_autocomplete.close()
      this.el_value = undefined
    }
  }
}
